import { render, staticRenderFns } from "./ShowCustomMetadatas.vue?vue&type=template&id=2a5ab9c0&scoped=true"
import script from "./ShowCustomMetadatas.vue?vue&type=script&lang=js"
export * from "./ShowCustomMetadatas.vue?vue&type=script&lang=js"
import style0 from "./ShowCustomMetadatas.vue?vue&type=style&index=0&id=2a5ab9c0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a5ab9c0",
  null
  
)

export default component.exports